/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section_6_Contact_DescInputs */

const en_privacy_section_6_contact_desc = /** @type {(inputs: Privacy_Section_6_Contact_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`retained for the duration of our business relationship or until you request deletion`)
};

const lv_privacy_section_6_contact_desc = /** @type {(inputs: Privacy_Section_6_Contact_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`glabāti mūsu darījumu attiecību laikā vai līdz brīdim, kad pieprasāt to dzēšanu`)
};

/**
* | output |
* | --- |
* | "retained for the duration of our business relationship or until you request deletion" |
*
* @param {Privacy_Section_6_Contact_DescInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const privacy_section_6_contact_desc = /** @type {((inputs?: Privacy_Section_6_Contact_DescInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section_6_Contact_DescInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_privacy_section_6_contact_desc(inputs)
	return en_privacy_section_6_contact_desc(inputs)
});